import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import {
  selectAuthLoading,
  selectIsAuthenticated,
  selectUser,
} from "../../redux/authReducer";
import { Loading } from "../shared/Loading";

/**
 * RoleProtectedRoute - protects routes based on authentication and role
 * Replacement for the old ProtectedRoute component
 */
const RoleProtectedRoute = ({
  children,
  allowedRoles = [],
  requireAuth = true,
}) => {
  const user = useSelector(selectUser);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loading = useSelector(selectAuthLoading);
  const location = useLocation();

  // Show loading state while checking authentication
  if (loading) {
    return <Loading fullScreen text="Loading..." />;
  }

  // Check if authentication is required and user is not authenticated
  if (requireAuth && !isAuthenticated) {
    // Redirect to login page but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user has the required role
  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Access Denied
          </h2>
          <p className="text-gray-600 mb-4">
            You don't have permission to access this page.
          </p>
          <a
            href="/dashboard"
            className="bg-custom-blue text-white px-6 py-2 rounded-lg hover:bg-custom-light-blue transition-colors inline-block"
          >
            Go to Dashboard
          </a>
        </div>
      </div>
    );
  }

  return children;
};

export default RoleProtectedRoute;
